import React, { Component } from 'react';
import { Redirect, Route } from 'react-router-dom';
import sessionManager from 'utils/managers/sessionManager';

const PrivateRoute = ({ component: Component, appState, ...rest }) => (
    <Route
        {...rest}
        render={props => {
            let returnComponent = <Component {...props} />;
            if (!appState.auth) {
                sessionManager.setState('nextUrl', props.match.url);
                returnComponent = (
                    <Redirect
                        to={{
                            pathname: '/login',
                            state: {
                                from: props.location
                            }
                        }}
                    />
                );
            } else if (
                appState.auth.user.status == 'pending' &&
                ![
                    '/email_confirmation',
                    '/email_verification/:token',
                    '/l/:hash'
                ].includes(props.match.path)
            ) {
                //sessionManager.setState('nextUrl', props.match.url);
                returnComponent = (
                    <Redirect
                        to={{
                            pathname: '/email_confirmation',
                            state: {
                                from: props.location
                            }
                        }}
                    />
                );
                //If the user signed up after being redirect to sign up, and has just clicked on email confirmation link,
                // confirming email address redirect user to the inital url
            } else if (
                appState.auth.user.status != 'pending' &&
                ['/email_confirmation', '/email_verification/:token'].includes(
                    props.match.path
                )
            ) {
                const nextUrl = sessionManager.getState('nextUrl');
                let url = '/quote';
                if (nextUrl) {
                    url = nextUrl;
                    sessionManager.unsetState('nextUrl');
                }

                returnComponent = (
                    <Redirect
                        to={{
                            pathname: url,
                            state: {
                                from: props.location
                            }
                        }}
                    />
                );
                //Logged in with valid Auth, but no profile
            } else if (
                ![
                    '/',
                    '/profile',
                    '/quote/:quoteId',
                    '/quote',
                    '/email_confirmation',
                    '/email_verification/:token',
                    '/l/:hash'
                ].includes(props.match.path) &&
                !appState.profile
            ) {
                sessionManager.setState('nextUrl', props.match.url);
                returnComponent = (
                    <Redirect
                        to={{
                            pathname: '/profile',
                            state: {
                                from: props.location
                            }
                        }}
                    />
                );

                //If the user is logged in after being redirected to loggin page
                //Redirect to initial page, and clear redirect cached link
            } else if (
                appState.auth &&
                appState.auth.user.status != 'pending' &&
                appState.profile &&
                sessionManager.getState('nextUrl')
            ) {
                const nextUrl = sessionManager.getState('nextUrl');
                sessionManager.unsetState('nextUrl');
                returnComponent = (
                    <Redirect
                        to={{
                            pathname: nextUrl,
                            state: {
                                from: props.location
                            }
                        }}
                    />
                );
            }

            return returnComponent;
        }}
    />
);
export default PrivateRoute;



// WEBPACK FOOTER //
// ./src/modules/router/PrivateRoute.jsx